export const HEALTHCHECK = 'HEALTHCHECK'
export const HEALTHCHECK_SUCCESS = 'HEALTHCHECK_SUCCESS'
export const HEALTHCHECK_FAILURE = 'HEALTHCHECK_FAILURE'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN = 'LOGIN'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const AUTH_CLEAR = 'AUTH_CLEAR'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const AUTHORIZE = 'AUTHORIZE'
export const AUTHORIZE_FAILURE = 'AUTHORIZE_FAILURE'
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CANNOT_USE = 'CANNOT_USE'

export const PATIENT_SEARCH = 'PATIENT_SEARCH'
export const PATIENT_SEARCH_SUCCESS = 'PATIENT_SEARCH_SUCCESS'
export const PATIENT_SEARCH_FAILURE = 'PATIENT_SEARCH_FAILURE'
export const PATIENT_SHOW = 'PATIENT_SHOW'
export const PATIENT_SHOW_SUCCESS = 'PATIENT_SHOW_SUCCESS'
export const PATIENT_SHOW_FAILURE = 'PATIENT_SHOW_FAILURE'
export const PATIENT_SHOW_CLEAR = 'PATIENT_SHOW_CLEAR'
export const PATIENT_NS_REMOVE = 'PATIENT_NS_REMOVE'
export const PATIENT_NS_REMOVE_FAILURE = 'PATIENT_NS_REMOVE_FAILURE'
export const PATIENT_NS_REMOVE_SUCCESS = 'PATIENT_NS_REMOVE_SUCCESS'

export const FACILITY_SEARCH = 'FACILITY_SEARCH'
export const FACILITY_SEARCH_SUCCESS = 'FACILITY_SEARCH_SUCCESS'
export const FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS = 'FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS'
export const FACILITY_SEARCH_FAILURE = 'FACILITY_SEARCH_FAILURE'
export const FACILITY_CLEAR = 'FACILITY_CLEAR'
export const FACILITY_AUTOCOMPLETE_CLEAR = 'FACILITY_AUTOCOMPLETE_CLEAR'
export const FACILITY_NOTICE_GET = 'FACILITY_NOTICE_GET'
export const FACILITY_NOTICE_GET_FAILURE = 'FACILITY_NOTICE_GET_FAILURE'
export const FACILITY_NOTICE_GET_SUCCESS = 'FACILITY_NOTICE_GET_SUCCESS'
export const FACILITY_NOTICE_COMPLETE = 'FACILITY_NOTICE_COMPLETE'
export const FACILITY_NOTICE_COMPLETE_FAILURE = 'FACILITY_NOTICE_COMPLETE_FAILURE'
export const FACILITY_NOTICE_COMPLETE_SUCCESS = 'FACILITY_NOTICE_COMPLETE_SUCCESS'
export const FACILITY_NOTICE_DELETE = 'FACILITY_NOTICE_DELETE'
export const FACILITY_NOTICE_DELETE_FAILURE = 'FACILITY_NOTICE_DELETE_FAILURE'
export const FACILITY_NOTICE_DELETE_SUCCESS = 'FACILITY_NOTICE_DELETE_SUCCESS'
export const FACILITY_HISTORY_SAVE = 'FACILITY_HISTORY_SAVE'
export const FACILITY_HISTORY_IMAGE_SAVE = 'FACILITY_HISTORY_IMAGE_SAVE'
export const FACILITY_HISTORY_SAVE_FAILURE = 'FACILITY_HISTORY_SAVE_FAILURE'
export const FACILITY_HISTORY_SAVE_SUCCESS = 'FACILITY_HISTORY_SAVE_SUCCESS'
export const FACILITY_HISTORY_GET = 'FACILITY_HISTORY_GET'
export const FACILITY_HISTORY_GET_FAILURE = 'FACILITY_HISTORY_GET_FAILURE'
export const FACILITY_HISTORY_GET_SUCCESS = 'FACILITY_HISTORY_GET_SUCCESS'
export const FACILITY_HISTORY_SEARCH = 'FACILITY_HISTORY_SEARCH'
export const FACILITY_HISTORY_SEARCH_FAILURE = 'FACILITY_HISTORY_SEARCH_FAILURE'
export const FACILITY_HISTORY_SEARCH_SUCCESS = 'FACILITY_HISTORY_SEARCH_SUCCESS'
export const FACILITY_SELECT = 'FACILITY_SELECT'
export const FACILITY_HISTORY_SELECT = 'FACILITY_HISTORY_SELECT'
export const FACILITY_DUPLICATE_CHECK = 'FACILITY_DUPLICATE_CHECK'
export const FACILITY_DUPLICATE_CHECK_SUCCESS = 'FACILITY_DUPLICATE_CHECK_SUCCESS'
export const FACILITY_DUPLICATE_CHECK_FAILURE = 'FACILITY_DUPLICATE_CHECK_FAILURE'
export const FACILITY_CODE_DUPLICATE = 'FACILITY_CODE_DUPLICATE'
export const FACILITY_SEARCH_ALL = 'FACILITY_SEARCH_ALL'
export const FACILITY_SEARCH_ALL_FAILURE = 'FACILITY_SEARCH_ALL_FAILURE'
export const FACILITY_SEARCH_ALL_SUCCESS = 'FACILITY_SEARCH_ALL_SUCCESS'
export const FACILITY_CHECKED = 'FACILITY_CHECKED'
export const FACILITY_SHOP_LIST_SAVE = 'FACILITY_SHOP_LIST_SAVE'
export const FACILITY_SEARCH_BY_SHOP = 'FACILITY_SEARCH_BY_SHOP'
export const FACILITY_SEARCH_BY_SHOP_FAILURE = 'FACILITY_SEARCH_BY_SHOP_FAILURE'
export const FACILITY_SEARCH_BY_SHOP_SUCCESS = 'FACILITY_SEARCH_BY_SHOP_SUCCESS'

export const FACILITY_HISTORY_DETAIL_SEARCH = 'FACILITY_HISTORY_DETAIL_SEARCH'
export const FACILITY_HISTORY_DETAIL_SEARCH_FAILURE = 'FACILITY_HISTORY_DETAIL_SEARCH_FAILURE'
export const FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS = 'FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS'
export const FACILITY_HISTORY_DETAIL_DELETE = 'FACILITY_HISTORY_DETAIL_DELETE'
export const FACILITY_HISTORY_DETAIL_DELETE_FAILURE = 'FACILITY_HISTORY_DETAIL_DELETE_FAILURE'
export const FACILITY_HISTORY_DETAIL_DELETE_SUCCESS = 'FACILITY_HISTORY_DETAIL_DELETE_SUCCESS'
export const FACILITY_HISTORY_DETAIL_NOTICE_MODIFY = 'FACILITY_HISTORY_DETAIL_NOTICE_MODIFY'
export const FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE = 'FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE'
export const FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS = 'FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS'
export const FACILITY_HISTORY_DETAIL_STOP = 'FACILITY_HISTORY_DETAIL_STOP'
export const FACILITY_HISTORY_DETAIL_STOP_FAILURE = 'FACILITY_HISTORY_DETAIL_STOP_FAILURE'
export const FACILITY_HISTORY_DETAIL_STOP_SUCCESS = 'FACILITY_HISTORY_DETAIL_STOP_SUCCESS'
export const FACILITY_HISTORY_DETAIL_SEND_MEDINFO = 'FACILITY_HISTORY_DETAIL_SEND_MEDINFO'
export const FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE = 'FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE'
export const FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS = 'FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS'
export const FACILITY_HISTORY_DETAIL_PRINT = 'FACILITY_HISTORY_DETAIL_PRINT'
export const FACILITY_HISTORY_DETAIL_PRINT_FAILURE = 'FACILITY_HISTORY_DETAIL_PRINT_FAILURE'
export const FACILITY_HISTORY_DETAIL_PRINT_SUCCESS = 'FACILITY_HISTORY_DETAIL_PRINT_SUCCESS'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS'
export const FACILITY_HISTORY_DETAIL_PRINT_DELETE = 'FACILITY_HISTORY_DETAIL_PRINT_DELETE'
export const FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE = 'FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE'
export const FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS = 'FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE'
export const FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS = 'FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS'
export const FACILITY_HISTORY_DETAIL_CLEAR = 'FACILITY_HISTORY_DETAIL_CLEAR'

export const CLINIC_SEARCH = 'CLINIC_SEARCH'
export const CLINIC_SEARCH_SUCCESS = 'CLINIC_SEARCH_SUCCESS'
export const CLINIC_SEARCH_FAILURE = 'CLINIC_SEARCH_FAILURE'
export const CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS = 'CLINIC_SEARCH_AUTOCOMPLETE_SUCCESS'
export const CLINICS_CLEAR = 'CLINICS_CLEAR'
export const CLINIC_CLEAR = 'CLINIC_CLEAR'
export const CLINIC_AUTOCOMPLETE_CLEAR = 'CLINIC_AUTOCOMPLETE_CLEAR'
export const CLINIC_SHOW = 'CLINIC_SHOW'
export const CLINIC_SHOW_FAILURE = 'CLINIC_SHOW_FAILURE'
export const CLINIC_SHOW_SUCCESS = 'CLINIC_SHOW_SUCCESS'
export const CLINIC_EDIT = 'CLINIC_EDIT'
export const CLINIC_EDIT_FAILURE = 'CLINIC_EDIT_FAILURE'
export const CLINIC_EDIT_SUCCESS = 'CLINIC_EDIT_SUCCESS'
export const CLINIC_DELETE = 'CLINIC_DELETE'
export const CLINIC_DELETE_FAILURE = 'CLINIC_DELETE_FAILURE'
export const CLINIC_DELETE_SUCCESS = 'CLINIC_DELETE_SUCCESS'
export const CLINIC_SAVE = 'CLINIC_SAVE'
export const CLINIC_IMAGE_SAVE = 'CLINIC_IMAGE_SAVE'
export const CLINIC_SAVE_FAILURE = 'CLINIC_SAVE_FAILURE'
export const CLINIC_SAVE_SUCCESS = 'CLINIC_SAVE_SUCCESS'
export const CLINIC_DUPLICATE_CHECK = 'CLINIC_DUPLICATE_CHECK'
export const CLINIC_DUPLICATE_CHECK_SUCCESS = 'CLINIC_DUPLICATE_CHECK_SUCCESS'
export const CLINIC_DUPLICATE_CHECK_ERROR = 'CLINIC_DUPLICATE_CHECK_ERROR'
export const CLINIC_NOTICE_MODIFY = 'CLINIC_NOTICE_MODIFY'
export const CLINIC_NOTICE_MODIFY_FAILURE = 'CLINIC_NOTICE_MODIFY_FAILURE'
export const CLINIC_NOTICE_MODIFY_SUCCESS = 'CLINIC_NOTICE_MODIFY_SUCCESS'
export const CLINIC_STOP = 'CLINIC_STOP'
export const CLINIC_STOP_FAILURE = 'CLINIC_STOP_FAILURE'
export const CLINIC_STOP_SUCCESS = 'CLINIC_STOP_SUCCESS'
export const CLINIC_SEND_MEDINFO = 'CLINIC_SEND_MEDINFO'
export const CLINIC_SEND_MEDINFO_FAILURE = 'CLINIC_SEND_MEDINFO_FAILURE'
export const CLINIC_SEND_MEDINFO_SUCCESS = 'CLINIC_SEND_MEDINFO_SUCCESS'
export const CLINIC_UPLOAD_START = 'CLINIC_UPLOAD_START'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF_FAILURE'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF_SUCCESS'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE'
export const CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS = 'CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS'
export const CLINIC_SHOP_LIST_SAVE = 'CLINIC_SHOP_LIST_SAVE'
export const CLINIC_SEARCH_BY_SHOP = 'CLINIC_SEARCH_BY_SHOP'
export const CLINIC_SEARCH_BY_SHOP_FAILURE = 'CLINIC_SEARCH_BY_SHOP_FAILURE'
export const CLINIC_SEARCH_BY_SHOP_SUCCESS = 'CLINIC_SEARCH_BY_SHOP_SUCCESS'
export const CLINIC_SEARCH_CLINIC_CODE = 'CLINIC_SEARCH_CLINIC_CODE'
export const CLINIC_SEARCH_CLINIC_CODE_FAILURE = 'CLINIC_SEARCH_CLINIC_CODE_FAILURE'
export const CLINIC_SEARCH_CLINIC_CODE_SUCCESS = 'CLINIC_SEARCH_CLINIC_CODE_SUCCESS'
export const CLEAR_CLINIC_CODE = 'CLEAR_CLINIC_CODE'

export const CARE_OFFICE_SEARCH = 'CARE_OFFICE_SEARCH'
export const CARE_OFFICE_SEARCH_SUCCESS = 'CARE_OFFICE_SEARCH_SUCCESS'
export const CARE_OFFICE_SEARCH_FAILURE = 'CARE_OFFICE_SEARCH_FAILURE'
export const CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS = 'CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS'
export const CARE_OFFICE_CLEAR = 'CARE_OFFICE_CLEAR'
export const CARE_OFFICE_AUTOCOMPLETE_CLEAR = 'CARE_OFFICE_AUTOCOMPLETE_CLEAR'
export const CARE_OFFICE_DETAIL_CLEAR = 'CARE_OFFICE_DETAIL_CLEAR'
export const CARE_OFFICE_EDIT_CLEAR = 'CARE_OFFICE_EDIT_CLEAR'
export const CARE_OFFICE_SEARCH_DETAIL = 'CARE_OFFICE_SEARCH_DETAIL'
export const CARE_OFFICE_SEARCH_DETAIL_FAILURE = 'CARE_OFFICE_SEARCH_DETAIL_FAILURE'
export const CARE_OFFICE_SEARCH_DETAIL_SUCCESS = 'CARE_OFFICE_SEARCH_DETAIL_SUCCESS'
export const CARE_OFFICE_EDIT = 'CARE_OFFICE_EDIT'
export const CARE_OFFICE_IMAGE_EDIT = 'CARE_OFFICE_IMAGE_EDIT'
export const CARE_OFFICE_EDIT_FAILURE = 'CARE_OFFICE_EDIT_FAILURE'
export const CARE_OFFICE_EDIT_SUCCESS = 'CARE_OFFICE_EDIT_SUCCESS'
export const CARE_OFFICE_DELETE = 'CARE_OFFICE_DELETE'
export const CARE_OFFICE_DELETE_FAILURE = 'CARE_OFFICE_DELETE_FAILURE'
export const CARE_OFFICE_DELETE_SUCCESS = 'CARE_OFFICE_DELETE_SUCCESS'
export const CARE_OFFICE_SEARCH_HISTORY = 'CARE_OFFICE_SEARCH_HISTORY'
export const CARE_OFFICE_SEARCH_HISTORY_FAILURE = 'CARE_OFFICE_SEARCH_HISTORY_FAILURE'
export const CARE_OFFICE_SEARCH_HISTORY_SUCCESS = 'CARE_OFFICE_SEARCH_HISTORY_SUCCESS'
export const CARE_OFFICE_SEND_MEDINFO = 'CARE_OFFICE_SEND_MEDINFO'
export const CARE_OFFICE_SEND_MEDINFO_FAILURE = 'CARE_OFFICE_SEND_MEDINFO_FAILURE'
export const CARE_OFFICE_SEND_MEDINFO_SUCCESS = 'CARE_OFFICE_SEND_MEDINFO_SUCCESS'
export const CARE_OFFICE_SET_ENABLE = 'CARE_OFFICE_SET_ENABLE'
export const CARE_OFFICE_SET_ENABLE_FAILURE = 'CARE_OFFICE_SET_ENABLE_FAILURE'
export const CARE_OFFICE_SET_ENABLE_SUCCESS = 'CARE_OFFICE_SET_ENABLE_SUCCESS'
export const CARE_OFFICE_NOTIFY = 'CARE_OFFICE_NOTIFY'
export const CARE_OFFICE_NOTIFY_CLEAR = 'CARE_OFFICE_NOTIFY_CLEAR'
export const CARE_OFFICE_DUPLICATE_CHECK = 'CARE_OFFICE_DUPLICATE_CHECK'
export const CARE_OFFICE_DUPLICATE_CHECK_SUCCESS = 'CARE_OFFICE_DUPLICATE_CHECK_SUCCESS'
export const CARE_OFFICE_DUPLICATE_CHECK_FAILURE = 'CARE_OFFICE_DUPLICATE_CHECK_FAILURE'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE'
export const CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS = 'CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS'
export const CARE_OFFICE_SHOP_LIST_SAVE = 'CARE_OFFICE_SHOP_LIST_SAVE'
export const CARE_OFFICE_SEARCH_BY_SHOP = 'CARE_OFFICE_SEARCH_BY_SHOP'
export const CARE_OFFICE_SEARCH_BY_SHOP_FAILURE = 'CARE_OFFICE_SEARCH_BY_SHOP_FAILURE'
export const CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS = 'CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS'

export const SHOP_SEARCH = 'SHOP_SEARCH'
export const SHOP_ALL_SEARCH = 'SHOP_ALL_SEARCH'
export const SHOP_ALL_SEARCH_FAILURE = 'SHOP_ALL_SEARCH_FAILURE'
export const SHOP_ALL_SEARCH_SUCCESS = 'SHOP_ALL_SEARCH_SUCCESS'
export const SHOP_SEARCH_SUCCESS = 'SHOP_SEARCH_SUCCESS'
export const SHOP_SEARCH_FAILURE = 'SHOP_SEARCH_FAILURE'
export const SHOP_LIST_SEARCH = 'SHOP_LIST_SEARCH'
export const SHOP_LIST_SEARCH_SUCCESS = 'SHOP_LIST_SEARCH_SUCCESS'
export const SHOP_LIST_SEARCH_FAILURE = 'SHOP_LIST_SEARCH_FAILURE'
export const SHOP_CLEAR = 'SHOP_CLEAR'
export const SHOP_GET = 'SHOP_GET'
export const SHOP_GET_SUCCESS = 'SHOP_GET_SUCCESS'
export const SHOP_GET_FAILURE = 'SHOP_GET_FAILURE'
export const SHOP_SELECT_GET = 'SHOP_SELECT_GET'
export const SHOP_SELECT_GET_SUCCESS = 'SHOP_SELECT_GET_SUCCESS'
export const SHOP_SELECT_GET_FAILURE = 'SHOP_SELECT_GET_FAILURE'
export const SHOP_UPDATE = 'SHOP_UPDATE'
export const SHOP_UPDATE_SUCCESS = 'SHOP_UPDATE_SUCCESS'
export const SHOP_UPDATE_FAILURE = 'SHOP_UPDATE_FAILURE'
export const MEDICINE_INFORMATION_SEARCH = 'MEDICINE_INFORMATION_SEARCH'
export const MEDICINE_INFORMATION_SEARCH_SUCCESS = 'MEDICINE_INFORMATION_SEARCH_SUCCESS'
export const MEDICINE_INFORMATION_SEARCH_FAILURE = 'MEDICINE_INFORMATION_SEARCH_FAILURE'
export const MEDICINE_INFORMATION_UPLOAD_START = 'MEDICINE_INFORMATION_UPLOAD_START'
export const MEDICINE_INFORMATION_CREATE = 'MEDICINE_INFORMATION_CREATE'
export const MEDICINE_INFORMATION_CREATE_SUCCESS = 'MEDICINE_INFORMATION_CREATE_SUCCESS'
export const MEDICINE_INFORMATION_CREATE_FAILURE = 'MEDICINE_INFORMATION_CREATE_FAILURE'
export const MEDICINE_INFORMATION_UPDATE = 'MEDICINE_INFORMATION_UPDATE'
export const MEDICINE_INFORMATION_UPDATE_SUCCESS = 'MEDICINE_INFORMATION_UPDATE_SUCCESS'
export const MEDICINE_INFORMATION_UPDATE_FAILURE = 'MEDICINE_INFORMATION_UPDATE_FAILURE'
export const MEDICINE_INFORMATION_PDF = 'MEDICINE_INFORMATION_PDF'
export const MEDICINE_INFORMATION_PDF_SUCCESS = 'MEDICINE_INFORMATION_PDF_SUCCESS'
export const MEDICINE_INFORMATION_PDF_FAILURE = 'MEDICINE_INFORMATION_PDF_FAILURE'
export const MEDICINE_INFORMATION_DELETE = 'MEDICINE_INFORMATION_DELETE'
export const MEDICINE_INFORMATION_DELETE_SUCCESS = 'MEDICINE_INFORMATION_DELETE_SUCCESS'
export const MEDICINE_INFORMATION_DELETE_FAILURE = 'MEDICINE_INFORMATION_DELETE_FAILURE'
export const PATIENT_INFORMATION_SEARCH = 'PATIENT_INFORMATION_SEARCH'
export const PATIENT_INFORMATION_SEARCH_SUCCESS = 'PATIENT_INFORMATION_SUCCESS'
export const PATIENT_INFORMATION_SEARCH_FAILURE = 'PATIENT_INFORMATION_FAILURE'
export const CLEAR_AUTH_STATUS = 'CLEAR_AUTH_STATUS'
export const DELIVERY_SEARCH = 'DELIVERY_SEARCH'
export const DELIVERY_SEARCH_SUCCESS = 'DELIVERY_SEARCH_SUCCESS'
export const DELIVERY_SEARCH_FAILURE = 'DELIVERY_SEARCH_FAILURE'
export const CLEAR_DELIVERY_SEARCH_PARAMS = 'CLEAR_DELIVERY_SEARCH_PARAMS'
export const REPORT_CHANGE_SEARCH = 'REPORT_CHANGE_SEARCH'
export const REPORT_CHANGE_SEARCH_SUCCESS = 'REPORT_CHANGE_SEARCH_SUCCESS'
export const REPORT_CHANGE_SEARCH_FAILURE = 'REPORT_CHANGE_SEARCH_FAILURE'
export const CHANGE_SHOP = 'CHANGE_SHOP'
export const CHANGE_SHOP_SUCCESS = 'CHANGE_SHOP_SUCCESS'
export const CHANGE_SHOP_FAILURE = 'CHANGE_SHOP_FAILURE'
export const PATIENT_UPDATE = 'PATIENT_UPDATE'
export const PATIENT_UPDATE_FAILURE = 'PATIENT_UPDATE_FAILURE'
export const PATIENT_UPDATE_SUCCESS = 'PATIENT_UPDATE_SUCCESS'
export const PATIENT_UPLOAD_START = 'PATIENT_UPLOAD_START'
export const PATIENT_AVATAR_UPLOAD = 'PATIENT_AVATAR_UPLOAD'
export const PATIENT_AVATAR_UPLOAD_FAILURE = 'PATIENT_AVATAR_UPLOAD_FAILURE'
export const PATIENT_AVATAR_UPLOAD_SUCCESS = 'PATIENT_AVATAR_UPLOAD_SUCCESS'
export const SET_PATIENT = 'SET_PATIENT'
export const SET_PATIENT_SUCCESS = 'SET_PATIENT_SUCCESS'
export const PATIENT_SEARCH_LIST = 'PATIENT_SEARCH_LIST'
export const PATIENT_SEARCH_LIST_ENABLE = 'PATIENT_SEARCH_LIST_ENABLE'
export const PATIENT_SET_SEL_FLAG = 'PATIENT_SET_SEL_FLAG'
export const PATIENT_SET_SEL_FLAG_SUCCESS = 'PATIENT_SET_SEL_FLAG_SUCCESS'
export const PATIENT_SET_SEL_FLAG_FAILURE = 'PATIENT_SET_SEL_FLAG_FAILURE'
export const PATIENT_CLEAR = 'PATIENT_CLEAR'
export const CLEAR_PATIENT_SEARCH_PARAMS = 'CLEAR_PATIENT_SEARCH_PARAMS'
export const CLEAR_MEDICINE_INFORMATION_SEARCH_PARAMS = 'CLEAR_MEDICINE_INFORMATION_SEARCH_PARAMS'
export const CLEAR_PATIENT_INFORMATION_SEARCH_PARAMS = 'CLEAR_PATIENT_INFORMATION_SEARCH_PARAMS'
export const PATIENT_SEARCH_PATIENT_CODE = 'PATIENT_SEARCH_PATIENT_CODE'
export const PATIENT_SEARCH_PATIENT_CODE_SUCCESS = 'PATIENT_SEARCH_PATIENT_CODE_SUCCESS'
export const PATIENT_SEARCH_PATIENT_CODE_FAILURE = 'PATIENT_SEARCH_PATIENT_CODE_FAILURE'
export const CLEAR_PATIENT_CODE = 'CLEAR_PATIENT_CODE'

export const DOCTOR_SEARCH = 'DOCTOR_SEARCH'
export const DOCTOR_SEARCH_SUCCESS = 'DOCTOR_SEARCH_SUCCESS'
export const DOCTOR_SEARCH_FAILURE = 'DOCTOR_SEARCH_FAILURE'
export const DOCTOR_CLEAR = 'DOCTOR_CLEAR'
export const DOCTOR_DETAIL_CLEAR = 'DOCTOR_DETAIL_CLEAR'
export const DOCTOR_EDIT_CLEAR = 'DOCTOR_EDIT_CLEAR'
export const DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS = 'DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS'
export const DOCTOR_AUTOCOMPLETE_CLEAR = 'DOCTOR_AUTOCOMPLETE_CLEAR'
export const DOCTOR_SEARCH_DETAIL = 'DOCTOR_SEARCH_DETAIL'
export const DOCTOR_SEARCH_DETAIL_FAILURE = 'DOCTOR_SEARCH_DETAIL_FAILURE'
export const DOCTOR_SEARCH_DETAIL_SUCCESS = 'DOCTOR_SEARCH_DETAIL_SUCCESS'
export const DOCTOR_EDIT = 'DOCTOR_EDIT'
export const DOCTOR_EDIT_FAILURE = 'DOCTOR_EDIT_FAILURE'
export const DOCTOR_EDIT_SUCCESS = 'DOCTOR_EDIT_SUCCESS'
export const DOCTOR_DELETE = 'DOCTOR_DELETE'
export const DOCTOR_DELETE_FAILURE = 'DOCTOR_DELETE_FAILURE'
export const DOCTOR_DELETE_SUCCESS = 'DOCTOR_DELETE_SUCCESS'
export const DOCTOR_SEARCH_HISTORY = 'DOCTOR_SEARCH_HISTORY'
export const DOCTOR_SEARCH_HISTORY_FAILURE = 'DOCTOR_SEARCH_HISTORY_FAILURE'
export const DOCTOR_SEARCH_HISTORY_SUCCESS = 'DOCTOR_SEARCH_HISTORY_SUCCESS'
export const DOCTOR_DUPLICATE_CHECK = 'DOCTOR_DUPLICATE_CHECK'
export const DOCTOR_DUPLICATE_CHECK_SUCCESS = 'DOCTOR_DUPLICATE_CHECK_SUCCESS'
export const DOCTOR_DUPLICATE_CHECK_FAILURE = 'DOCTOR_DUPLICATE_CHECK_FAILURE'
export const DOCTOR_MSG_ALERT = 'DOCTOR_MSG_ALERT'
export const DOCTOR_SEARCH_DOCTOR_CODE = 'DOCTOR_SEARCH_DOCTOR_CODE'
export const DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS = 'DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS'
export const DOCTOR_SEARCH_DOCTOR_CODE_FAILURE = 'DOCTOR_SEARCH_DOCTOR_CODE_FAILURE'
export const CLEAR_DOCTOR_CODE = 'CLEAR_DOCTOR_CODE'

export const CAREMAN_SEARCH = 'CAREMAN_SEARCH'
export const CAREMAN_SEARCH_SUCCESS = 'CAREMAN_SEARCH_SUCCESS'
export const CAREMAN_SEARCH_FAILURE = 'CAREMAN_SEARCH_FAILURE'
export const CAREMAN_CLEAR = 'CAREMAN_CLEAR'
export const CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS = 'CAREMAN_SEARCH_AUTOCOMPLETE_SUCCESS'
export const CAREMAN_AUTOCOMPLETE_CLEAR = 'CAREMAN_AUTOCOMPLETE_CLEAR'
export const CAREMAN_SEARCH_DETAIL = 'CAREMAN_SEARCH_DETAIL'
export const CAREMAN_SEARCH_DETAIL_FAILURE = 'CAREMAN_SEARCH_DETAIL_FAILURE'
export const CAREMAN_SEARCH_DETAIL_SUCCESS = 'CAREMAN_SEARCH_DETAIL_SUCCESS'
export const CAREMAN_DETAIL_CLEAR = 'CAREMAN_DETAIL_CLEAR'
export const CAREMAN_EDIT = 'CAREMAN_EDIT'
export const CAREMAN_EDIT_FAILURE = 'CAREMAN_EDIT_FAILURE'
export const CAREMAN_EDIT_SUCCESS = 'CAREMAN_EDIT_SUCCESS'
export const CAREMAN_EDIT_CLEAR = 'CAREMAN_EDIT_CLEAR'
export const CAREMAN_SEARCH_HISTORY = 'CAREMAN_SEARCH_HISTORY'
export const CAREMAN_SEARCH_HISTORY_FAILURE = 'CAREMAN_SEARCH_HISTORY_FAILURE'
export const CAREMAN_SEARCH_HISTORY_SUCCESS = 'CAREMAN_SEARCH_HISTORY_SUCCESS'
export const CAREMAN_DELETE = 'CAREMAN_DELETE'
export const CAREMAN_DELETE_FAILURE = 'CAREMAN_DELETE_FAILURE'
export const CAREMAN_DELETE_SUCCESS = 'CAREMAN_DELETE_SUCCESS'
export const CAREMAN_DUPLICATE_CHECK = 'CAREMAN_DUPLICATE_CHECK'
export const CAREMAN_DUPLICATE_CHECK_SUCCESS = 'CAREMAN_DUPLICATE_CHECK_SUCCESS'
export const CAREMAN_DUPLICATE_CHECK_FAILURE = 'CAREMAN_DUPLICATE_CHECK_FAILURE'
export const CAREMAN_MSG_ALERT = 'CAREMAN_MSG_ALERT'

export const PHRASE_SEARCH = 'PHRASE_SEARCH'
export const PHRASE_SEARCH_SUCCESS = 'PHRASE_SEARCH_SUCCESS'
export const PHRASE_SEARCH_FAILURE = 'PHRASE_SEARCH_FAILURE'
export const PHRASE_CLEAR = 'PHRASE_CLEAR'
export const PHRASE_TYPE_SEARCH = 'PHRASE_TYPE_SEARCH'
export const PHRASE_TYPE_SEARCH_SUCCESS = 'PHRASE_TYPE_SEARCH_SUCCESS'
export const PHRASE_TYPE_SEARCH_FAILURE = 'PHRASE_TYPE_SEARCH_FAILURE'
export const PHRASE_SAVE = 'PHRASE_SAVE'
export const PHRASE_SAVE_SUCCESS = 'PHRASE_SAVE_SUCCESS'
export const PHRASE_SAVE_FAILURE = 'PHRASE_SAVE_FAILURE'
export const PHRASE_USE = 'PHRASE_USE'
export const PHRASE_USE_SUCCESS = 'PHRASE_USE_SUCCESS'
export const PHRASE_USE_FAILURE = 'PHRASE_USE_FAILURE'
export const PHRASE_DELETE = 'PHRASE_DELETE'
export const PHRASE_DELETE_SUCCESS = 'PHRASE_DELETE_SUCCESS'
export const PHRASE_DELETE_FAILURE = 'PHRASE_DELETE_FAILURE'

export const PLAN_GET = 'PLAN_GET'
export const PLAN_GET_SUCCESS = 'PLAN_GET_SUCCESS'
export const PLAN_GET_FAILURE = 'PLAN_GET_FAILURE'
export const PLAN_SAVE = 'PLAN_SAVE'
export const PLAN_SAVE_SUCCESS = 'PLAN_SAVE_SUCCESS'
export const PLAN_SAVE_FAILURE = 'PLAN_SAVE_FAILURE'
export const PLAN_NEXT_MONTH_CHECK = 'PLAN_NEXT_MONTH_CHECK'
export const PLAN_NEXT_MONTH_CHECK_SUCCESS = 'PLAN_NEXT_MONTH_CHECK_SUCCESS'
export const PLAN_NEXT_MONTH_CHECK_FAILURE = 'PLAN_NEXT_MONTH_CHECK_FAILURE'
export const PLAN_EDIT_NEXT_MONTH = 'PLAN_EDIT_NEXT_MONTH'
export const PLAN_EDIT_NEXT_MONTH_SUCCESS = 'PLAN_EDIT_NEXT_MONTH_SUCCESS'
export const PLAN_EDIT_NEXT_MONTH_FAILURE = 'PLAN_EDIT_NEXT_MONTH_FAILURE'
export const PLAN_COPY_EDIT = 'PLAN_COPY_EDIT'
export const PLAN_COPY_EDIT_SUCCESS = 'PLAN_COPY_EDIT_SUCCESS'
export const PLAN_COPY_EDIT_FAILURE = 'PLAN_COPY_EDIT_FAILURE'
export const PLAN_SEARCH = 'PLAN_SEARCH'
export const PLAN_SEARCH_SUCCESS = 'PLAN_SEARCH_SUCCESS'
export const PLAN_SEARCH_FAILURE = 'PLAN_SEARCH_FAILURE'
export const PLAN_EXIST_NEXT_MONTH = 'PLAN_EXIST_NEXT_MONTH'
export const PLAN_EXIST_NEXT_MONTH_SUCCESS = 'PLAN_EXIST_NEXT_MONTH_SUCCESS'
export const PLAN_EXIST_NEXT_MONTH_FAILURE = 'PLAN_EXIST_NEXT_MONTH_FAILURE'
export const PLAN_SAVE_NEXT_MONTH = 'PLAN_SAVE_NEXT_MONTH'
export const PLAN_SAVE_NEXT_MONTH_SUCCESS = 'PLAN_SAVE_NEXT_MONTH_SUCCESS'
export const PLAN_SAVE_NEXT_MONTH_FAILURE = 'PLAN_SAVE_NEXT_MONTH_FAILURE'
export const PLAN_SET_ENABLE_PATIENT = 'PLAN_SET_ENABLE_PATIENT'
export const PLAN_SET_ENABLE_PATIENT_SUCCESS = 'PLAN_SET_ENABLE_PATIENT_SUCCESS'
export const PLAN_SET_ENABLE_PATIENT_FAILURE = 'PLAN_SET_ENABLE_PATIENT_FAILURE'
export const PLAN_REMOVE = 'PLAN_REMOVE'
export const PLAN_REMOVE_SUCCESS = 'PLAN_REMOVE_SUCCESS'
export const PLAN_REMOVE_FAILURE = 'PLAN_REMOVE_FAILURE'
export const PLAN_PDF = 'PLAN_PDF'
export const PLAN_PDF_SUCCESS = 'PLAN_PDF_SUCCESS'
export const PLAN_PDF_FAILURE = 'PLAN_PDF_FAILURE'
export const PLAN_REMOVE_PDF = 'PLAN_REMOVE_PDF'
export const PLAN_REMOVE_PDF_SUCCESS = 'PLAN_REMOVE_PDF_SUCCESS'
export const PLAN_REMOVE_PDF_FAILURE = 'PLAN_REMOVE_PDF_FAILURE'
export const PLAN_CLEAR = 'PLAN_CLEAR'
export const PLAN_MSG_ALERT = 'PLAN_MSG_ALERT'
export const PLAN_LIST_SEARCH = 'PLAN_LIST_SEARCH'
export const PLAN_LIST_SEARCH_SUCCESS = 'PLAN_LIST_SEARCH_SUCCESS'
export const PLAN_LIST_SEARCH_FAILURE = 'PLAN_LIST_SEARCH_FAILURE'
export const PLAN_LIST_SEARCH_CLEAR = 'PLAN_LIST_SEARCH_CLEAR'

export const DOWNLOAD_REPORT_SEARCH = 'DOWNLOAD_REPORT_SEARCH'
export const DOWNLOAD_PLAN_SEARCH = 'DOWNLOAD_PLAN_SEARCH'
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT'
export const DOWNLOAD_PLAN = 'DOWNLOAD_PLAN'
export const DOWNLOAD_SEARCH_SUCCESS = 'DOWNLOAD_SEARCH_SUCCESS'
export const DOWNLOAD_SEARCH_FAILURE = 'DOWNLOAD_SEARCH_FAILURE'
export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS'
export const DOWNLOAD_FAILURE = 'DOWNLOAD_FAILURE'
export const DOWNLOAD_CANCEL = 'DOWNLOAD_CANCEL'
export const DOWNLOAD_CANCEL_SUCCESS = 'DOWNLOAD_CANCEL_SUCCESS'
export const DOWNLOAD_CANCEL_FAILURE = 'DOWNLOAD_CANCEL_FAILURE'
export const DOWNLOAD_MSG_ALERT = 'DOWNLOAD_MSG_ALERT'
export const DOWNLOAD_NOTIFY_CLEAR = 'DOWNLOAD_NOTIFY_CLEAR'

export const ADDRESS_GET = 'ADDRESS_GET'
export const ADDRESS_GET_SUCCESS = 'ADDRESS_GET_SUCCESS'
export const ADDRESS_GET_FAILURE = 'ADDRESS_GET_FAILURE'
export const REPORT_HISTORY_SEARCH = 'REPORT_HISTORY_SEARCH'
export const REPORT_HISTORY_SEARCH_SUCCESS = 'REPORT_HISTORY_SEARCH_SUCCESS'
export const REPORT_HISTORY_SEARCH_FAILURE = 'REPORT_HISTORY_SEARCH_FAILURE'
export const REPORT_HISTORY_CLEAR = 'REPORT_HISTORY_CLEAR'
export const REPORT_HISTORY_SET_SEND_STATUS = 'REPORT_HISTORY_SET_SEND_STATUS'
export const REPORT_HISTORY_SET_SEND_STATUS_SUCCESS = 'REPORT_HISTORY_SET_SEND_STATUS_SUCCESS'
export const REPORT_HISTORY_SET_SEND_STATUS_FAILURE = 'REPORT_HISTORY_SET_SEND_STATUS_FAILURE'
export const REPORT_HISTORY_GET_SEND_FAILS_SUM = 'REPORT_HISTORY_GET_SEND_FAILS_SUM'
export const REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS = 'REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS'
export const REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE = 'REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE'
export const REPORT_BATCH_HISTORY_SEARCH = 'REPORT_BATCH_HISTORY_SEARCH'
export const REPORT_BATCH_HISTORY_SEARCH_SUCCESS = 'REPORT_BATCH_HISTORY_SEARCH_SUCCESS'
export const REPORT_BATCH_HISTORY_SEARCH_FAILURE = 'REPORT_BATCH_HISTORY_SEARCH_FAILURE'
export const REPORT_BATCH_HISTORY_RESEND = 'REPORT_BATCH_HISTORY_RESEND'
export const REPORT_BATCH_HISTORY_RESEND_SUCCESS = 'REPORT_BATCH_HISTORY_RESEND_SUCCESS'
export const REPORT_BATCH_HISTORY_RESEND_FAILURE = 'REPORT_BATCH_HISTORY_RESEND_FAILURE'

export const MEDICINE_SEARCH = 'MEDICINE_SEARCH'
export const MEDICINE_SEARCH_SUCCESS = 'MEDICINE_SEARCH_SUCCESS'
export const MEDICINE_SEARCH_FAILURE = 'MEDICINE_SEARCH_FAILURE'
export const MEDICINE_TYPE_SEARCH = 'MEDICINE_TYPE_SEARCH'
export const MEDICINE_TYPE_SEARCH_SUCCESS = 'MEDICINE_TYPE_SEARCH_SUCCESS'
export const MEDICINE_TYPE_SEARCH_FAILURE = 'MEDICINE_TYPE_SEARCH_FAILURE'
export const MEDICINE_CLEAR = 'MEDICINE_CLEAR'
export const MEDICINE_DETAIL = 'MEDICINE_DETAIL'
export const MEDICINE_DETAIL_SUCCESS = 'MEDICINE_DETAIL_SUCCESS'
export const MEDICINE_DETAIL_FAILURE = 'MEDICINE_DETAIL_FAILURE'
export const MEDICINE_DETAIL_CLEAR = 'MEDICINE_DETAIL_CLEAR'
export const MEDICINE_UPDATE_COMMENT = 'MEDICINE_UPDATE_COMMENT'
export const MEDICINE_UPDATE_COMMENT_SUCCESS = 'MEDICINE_UPDATE_COMMENT_SUCCESS'
export const MEDICINE_UPDATE_COMMENT_FAILURE = 'MEDICINE_UPDATE_COMMENT_FAILURE'
export const MEDICINE_CSV_IMPORT_START = 'MEDICINE_CSV_IMPORT_START'
export const MEDICINE_CSV_IMPORT = 'MEDICINE_CSV_IMPORT'
export const MEDICINE_CSV_IMPORT_FAILURE = 'MEDICINE_CSV_IMPORT_FAILURE'
export const MEDICINE_CSV_IMPORT_SUCCESS = 'MEDICINE_CSV_IMPORT_SUCCESS'
export const MEDICINE_CSV_MASTER_IMPORT_START = 'MEDICINE_CSV_MASTER_IMPORT_START'
export const MEDICINE_CSV_MASTER_IMPORT = 'MEDICINE_CSV_MASTER_IMPORT'
export const MEDICINE_CSV_MASTER_IMPORT_FAILURE = 'MEDICINE_CSV_MASTER_IMPORT_FAILURE'
export const MEDICINE_CSV_MASTER_IMPORT_SUCCESS = 'MEDICINE_CSV_MASTER_IMPORT_SUCCESS'

export const USER_SEARCH = 'USER_SEARCH'
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS'
export const USER_SEARCH_FAILURE = 'USER_SEARCH_FAILURE'
export const USER_CLEAR = 'USER_CLEAR'
export const USER_SEARCH_AUTOCOMPLETE_SUCCESS = 'USER_SEARCH_AUTOCOMPLETE_SUCCESS'
export const USER_AUTOCOMPLETE_CLEAR = 'USER_AUTOCOMPLETE_CLEAR'
export const USER_ADMIN_PHARMACIST = 'USER_ADMIN_PHARMACIST'
export const USER_ADMIN_PHARMACIST_SUCCESS = 'USER_ADMIN_PHARMACIST_SUCCESS'
export const USER_ADMIN_PHARMACIST_FAILURE = 'USER_ADMIN_PHARMACIST_FAILURE'

export const REPORT_SEARCH = 'REPORT_SEARCH'
export const REPORT_SEARCH_SUCCESS = 'REPORT_SEARCH_SUCCESS'
export const REPORT_SEARCH_FAILURE = 'REPORT_SEARCH_FAILURE'
export const REPORT_SEARCH_CLEAR = 'REPORT_SEARCH_CLEAR'
export const REPORT_LIST_SEARCH = 'REPORT_LIST_SEARCH'
export const REPORT_LIST_SEARCH_SUCCESS = 'REPORT_LIST_SEARCH_SUCCESS'
export const REPORT_LIST_SEARCH_FAILURE = 'REPORT_LIST_SEARCH_FAILURE'
export const REPORT_LIST_SEARCH_CLEAR = 'REPORT_LIST_SEARCH_CLEAR'
export const REPORT_DELETE = 'REPORT_DELETE'
export const REPORT_DELETE_SUCCESS = 'REPORT_DELETE_SUCCESS'
export const REPORT_DELETE_FAILURE = 'REPORT_DELETE_FAILURE'
export const REPORT_PDF = 'REPORT_PDF'
export const REPORT_PDF_SUCCESS = 'REPORT_PDF_SUCCESS'
export const REPORT_PDF_FAILURE = 'REPORT_PDF_FAILURE'
export const REPORT_REMOVE_PDF = 'REPORT_REMOVE_PDF'
export const REPORT_REMOVE_PDF_SUCCESS = 'REPORT_REMOVE_PDF_SUCCESS'
export const REPORT_REMOVE_PDF_FAILURE = 'REPORT_REMOVE_PDF_FAILURE'
export const REPORT_MEDICINE_SEARCH = 'REPORT_MEDICINE_SEARCH'
export const REPORT_MEDICINE_SEARCH_SUCCESS = 'REPORT_MEDICINE_SEARCH_SUCCESS'
export const REPORT_MEDICINE_SEARCH_FAILURE = 'REPORT_MEDICINE_SEARCH_FAILURE'

export const REPORT_EDIT_SEARCH = 'REPORT_EDIT_SEARCH'
export const REPORT_EDIT_SEARCH_SUCCESS = 'REPORT_EDIT_SEARCH_SUCCESS'
export const REPORT_EDIT_SEARCH_FAILURE = 'REPORT_EDIT_SEARCH_FAILURE'
export const REPORT_EDIT_CLEAR = 'REPORT_EDIT_CLEAR'
export const REPORT_EDIT_SAVE = 'REPORT_EDIT_SAVE'
export const REPORT_EDIT_SAVE_SUCCESS = 'REPORT_EDIT_SAVE_SUCCESS'
export const REPORT_EDIT_SAVE_FAILURE = 'REPORT_EDIT_SAVE_FAILURE'
export const REPORT_EDIT_ALL_SAVE = 'REPORT_EDIT_ALL_SAVE'
export const REPORT_EDIT_ALL_SAVE_SUCCESS = 'REPORT_EDIT_ALL_SAVE_SUCCESS'
export const REPORT_EDIT_ALL_SAVE_FAILURE = 'REPORT_EDIT_ALL_SAVE_FAILURE'
export const REPORT_EDIT_ADD_NEW_REPORT = 'REPORT_EDIT_ADD_NEW_REPORT'
export const REPORT_EDIT_ADD_NEW_REPORT_SUCCESS = 'REPORT_EDIT_ADD_NEW_REPORT_SUCCESS'
export const REPORT_EDIT_ADD_NEW_REPORT_FAILURE = 'REPORT_EDIT_ADD_NEW_REPORT_FAILURE'
export const REPORT_EDIT_PRINT = 'REPORT_EDIT_PRINT'
export const REPORT_EDIT_PRINT_SUCCESS = 'REPORT_EDIT_PRINT_SUCCESS'
export const REPORT_EDIT_PRINT_FAILURE = 'REPORT_EDIT_PRINT_FAILURE'
export const REPORT_EDIT_PRINT_DEL = 'REPORT_EDIT_PRINT_DEL'
export const REPORT_EDIT_PRINT_DEL_SUCCESS = 'REPORT_EDIT_PRINT_DEL_SUCCESS'
export const REPORT_EDIT_PRINT_DEL_FAILURE = 'REPORT_EDIT_PRINT_DEL_FAILURE'
export const REPORT_EDIT_SEARCH_HIST = 'REPORT_EDIT_SEARCH_HIST'
export const REPORT_EDIT_SEARCH_HIST_SUCCESS = 'REPORT_EDIT_SEARCH_HIST_SUCCESS'
export const REPORT_EDIT_SEARCH_HIST_FAILURE = 'REPORT_EDIT_SEARCH_HIST_FAILURE'
export const REPORT_EDIT_SEARCH_PHRASE = 'REPORT_EDIT_SEARCH_PHRASE'
export const REPORT_EDIT_SEARCH_PHRASE_SUCCESS = 'REPORT_EDIT_SEARCH_PHRASE_SUCCESS'
export const REPORT_EDIT_SEARCH_PHRASE_FAILURE = 'REPORT_EDIT_SEARCH_PHRASE_FAILURE'
export const REPORT_EDIT_AUTO_CONSULT_POINTS = 'REPORT_EDIT_AUTO_CONSULT_POINTS'
export const REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS = 'REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS'
export const REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE = 'REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE'
export const REPORT_EDIT_CAREOFFICE_SEND_INFO = 'REPORT_EDIT_CAREOFFICE_SEND_INFO'
export const REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS = 'REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS'
export const REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE = 'REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE'
export const REPORT_EDIT_CLINIC_SEND_INFO = 'REPORT_EDIT_CLINIC_SEND_INFO'
export const REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS = 'REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS'
export const REPORT_EDIT_CLINIC_SEND_INFO_FAILURE = 'REPORT_EDIT_CLINIC_SEND_INFO_FAILURE'
export const REPORT_EDIT_REPORT_DELETE_NEW_REPORT = 'REPORT_EDIT_REPORT_DELETE_NEW_REPORT'
export const REPORT_EDIT_MSG_ALERT = 'REPORT_EDIT_MSG_ALERT'

export const REPORT_RE_SEND = 'REPORT_RE_SEND'
export const REPORT_RE_SEND_SUCCESS = 'REPORT_RE_SEND_SUCCESS'
export const REPORT_RE_SEND_FAILURE = 'REPORT_RE_SEND_FAILURE'
export const REPORT_SEND_CANCEL = 'REPORT_SEND_CANCEL'
export const REPORT_SEND_CANCEL_SUCCESS = 'REPORT_SEND_CANCEL_SUCCESS'
export const REPORT_SEND_CANCEL_FAILURE = 'REPORT_SEND_CANCEL_FAILURE'
export const REPORT_SEND_RESTART = 'REPORT_SEND_RESTART'
export const REPORT_SEND_RESTART_SUCCESS = 'REPORT_SEND_RESTART_SUCCESS'
export const REPORT_SEND_RESTART_FAILURE = 'REPORT_SEND_RESTART_FAILURE'

export const SEND_PDF_CSV_ADDRESS_PARSE = 'SEND_PDF_CSV_ADDRESS_PARSE'
export const SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS = 'SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS'
export const SEND_PDF_CSV_ADDRESS_PARSE_FAILURE = 'SEND_PDF_CSV_ADDRESS_PARSE_FAILURE'
export const SEND_PDF_ADDRESS_SEARCH = 'SEND_PDF_ADDRESS_SEARCH'
export const SEND_PDF_ADDRESS_SEARCH_SUCCESS = 'SEND_PDF_ADDRESS_SEARCH_SUCCESS'
export const SEND_PDF_ADDRESS_SEARCH_FAILURE = 'SEND_PDF_ADDRESS_SEARCH_FAILURE'
export const SEND_PDF_ADDRESS_DELETE = 'SEND_PDF_ADDRESS_DELETE'
export const SEND_PDF_ADDRESS_DELETE_ALL = 'SEND_PDF_ADDRESS_DELETE_ALL'
export const SEND_PDF_UPLOAD_PDF_FILE = 'SEND_PDF_UPLOAD_PDF_FILE'
export const SEND_PDF_UPLOAD_PDF_FILE_SUCCESS = 'SEND_PDF_UPLOAD_PDF_FILE_SUCCESS'
export const SEND_PDF_UPLOAD_PDF_FILE_FAILURE = 'SEND_PDF_UPLOAD_PDF_FILE_FAILURE'
export const SEND_PDF_SEND = 'SEND_PDF_SEND'
export const SEND_PDF_SEND_SUCCESS = 'SEND_PDF_SEND_SUCCESS'
export const SEND_PDF_SEND_FAILURE = 'SEND_PDF_SEND_FAILURE'
export const SEND_PDF_SEND_COMPLETED = 'SEND_PDF_SEND_COMPLETED'
export const SEND_PDF_SEND_CANCELED = 'SEND_PDF_SEND_CANCELED'
export const SEND_PDF_FAX_STATUS_GET = 'SEND_PDF_FAX_STATUS_GET'
export const SEND_PDF_FAX_STATUS_GET_SUCCESS = 'SEND_PDF_FAX_STATUS_GET_SUCCESS'
export const SEND_PDF_FAX_STATUS_GET_FAILURE = 'SEND_PDF_FAX_STATUS_GET_FAILURE'
export const SEND_PDF_MSG_ALERT = 'SEND_PDF_MSG_ALERT'
export const SEND_PDF_HISTORY_SEARCH = 'SEND_PDF_HISTORY_SEARCH'
export const SEND_PDF_HISTORY_SEARCH_FAILURE = 'SEND_PDF_HISTORY_SEARCH_FAILURE'
export const SEND_PDF_HISTORY_SEARCH_SUCCESS = 'SEND_PDF_HISTORY_SEARCH_SUCCESS'

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD'
export const PASSWORD_RESET_MAIL_SEND = 'PASSWORD_RESET_MAIL_SEND'
export const PASSWORD_RESET_MAIL_SEND_SUCCESS = 'PASSWORD_RESET_MAIL_SEND_SUCCESS'
export const PASSWORD_RESET_MAIL_SEND_FAILURE = 'PASSWORD_RESET_MAIL_SEND_FAILURE'
export const PASSWORD_RESET_UPDATE = 'PASSWORD_RESET_UPDATE'
export const PASSWORD_RESET_UPDATE_SUCCESS = 'PASSWORD_RESET_UPDATE_SUCCESS'
export const PASSWORD_RESET_UPDATE_FAILURE = 'PASSWORD_RESET_UPDATE_FAILURE'

export const IMAGE_UPLOAD_START = 'IMAGE_UPLOAD_START'
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD'
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS'
export const IMAGE_UPLOAD_FAILURE = 'IMAGE_UPLOAD_FAILURE'

export const MONTHLY_CHECK = 'MONTHLY_CHECK'
export const MONTHLY_CHECK_SUCCESS = 'MONTHLY_CHECK_SUCCESS'
export const MONTHLY_CHECK_FAILURE = 'MONTHLY_CHECK_FAILURE'
export const MONTHLY_CHECK_CSV = 'MONTHLY_CHECK_CSV'
export const MONTHLY_CHECK_CSV_SUCCESS = 'MONTHLY_CHECK_CSV_SUCCESS'
export const MONTHLY_CHECK_CSV_FAILURE = 'MONTHLY_CHECK_CSV_FAILURE'

export const NSIPS_REPORT_EDIT_SEARCH = 'NSIPS_REPORT_EDIT_SEARCH'
export const NSIPS_REPORT_EDIT_SEARCH_SUCCESS = 'NSIPS_REPORT_EDIT_SEARCH_SUCCESS'
export const NSIPS_REPORT_EDIT_SEARCH_FAILURE = 'NSIPS_REPORT_EDIT_SEARCH_FAILURE'
export const NSIPS_REPORT_EDIT_CLEAR = 'NSIPS_REPORT_EDIT_CLEAR'
export const NSIPS_REPORT_EDIT_SAVE = 'NSIPS_REPORT_EDIT_SAVE'
export const NSIPS_REPORT_EDIT_SAVE_SUCCESS = 'NSIPS_REPORT_EDIT_SAVE_SUCCESS'
export const NSIPS_REPORT_EDIT_SAVE_FAILURE = 'NSIPS_REPORT_EDIT_SAVE_FAILURE'
export const NSIPS_REPORT_EDIT_ALL_SAVE = 'NSIPS_REPORT_EDIT_ALL_SAVE'
export const NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS = 'NSIPS_REPORT_EDIT_ALL_SAVE_SUCCESS'
export const NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE = 'NSIPS_REPORT_EDIT_ALL_SAVE_FAILURE'
export const NSIPS_REPORT_EDIT_SEARCH_HIST = 'NSIPS_REPORT_EDIT_SEARCH_HIST'
export const NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS = 'NSIPS_REPORT_EDIT_SEARCH_HIST_SUCCESS'
export const NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE = 'NSIPS_REPORT_EDIT_SEARCH_HIST_FAILURE'
export const NSIPS_REPORT_EDIT_SEARCH_PHRASE = 'NSIPS_REPORT_EDIT_SEARCH_PHRASE'
export const NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS = 'NSIPS_REPORT_EDIT_SEARCH_PHRASE_SUCCESS'
export const NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE = 'NSIPS_REPORT_EDIT_SEARCH_PHRASE_FAILURE'
export const NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS = 'NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS'
export const NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS = 'NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_SUCCESS'
export const NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE = 'NSIPS_REPORT_EDIT_AUTO_CONSULT_POINTS_FAILURE'
export const NSIPS_REPORT_EDIT_ADD_NEW_REPORT = 'NSIPS_REPORT_EDIT_ADD_NEW_REPORT'
export const NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS = 'NSIPS_REPORT_EDIT_ADD_NEW_REPORT_SUCCESS'
export const NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE = 'NSIPS_REPORT_EDIT_ADD_NEW_REPORT_FAILURE'
export const NSIPS_REPORT_EDIT_PRINT = 'NSIPS_REPORT_EDIT_PRINT'
export const NSIPS_REPORT_EDIT_PRINT_SUCCESS = 'NSIPS_REPORT_EDIT_PRINT_SUCCESS'
export const NSIPS_REPORT_EDIT_PRINT_FAILURE = 'NSIPS_REPORT_EDIT_PRINT_FAILURE'
export const NSIPS_REPORT_EDIT_PRINT_DEL = 'NSIPS_REPORT_EDIT_PRINT_DEL'
export const NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS = 'NSIPS_REPORT_EDIT_PRINT_DEL_SUCCESS'
export const NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE = 'NSIPS_REPORT_EDIT_PRINT_DEL_FAILURE'
export const NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO = 'NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO'
export const NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS = 'NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_SUCCESS'
export const NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE = 'NSIPS_REPORT_EDIT_CAREOFFICE_SEND_INFO_FAILURE'
export const NSIPS_REPORT_EDIT_CLINIC_SEND_INFO = 'NSIPS_REPORT_EDIT_CLINIC_SEND_INFO'
export const NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS = 'NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_SUCCESS'
export const NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE = 'NSIPS_REPORT_EDIT_CLINIC_SEND_INFO_FAILURE'
export const NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT = 'NSIPS_REPORT_EDIT_REPORT_DELETE_NEW_REPORT'
export const NSIPS_REPORT_EDIT_MSG_ALERT = 'NSIPS_REPORT_EDIT_MSG_ALERT'
export const NSIPS_SEARCH = 'NSIPS_SEARCH'
export const NSIPS_SEARCH_SUCCESS = 'NSIPS_SEARCH_SUCCESS'
export const NSIPS_SEARCH_FAILURE = 'NSIPS_SEARCH_FAILURE'
export const NSIPS_DELIVERY_DATE = 'NSIPS_DELIVERY_DATE'
export const NSIPS_DELIVERY_DATE_SUCCESS = 'NSIPS_DELIVERY_DATE_SUCCESS'
export const NSIPS_DELIVERY_DATE_FAILURE = 'NSIPS_DELIVERY_DATE_FAILURE'
export const NSIPS_PRESCRIPTION_COMPARISON = 'NSIPS_PRESCRIPTION_COMPARISON'
export const NSIPS_PRESCRIPTION_COMPARISON_SUCCESS = 'NSIPS_PRESCRIPTION_COMPARISON_SUCCESS'
export const NSIPS_PRESCRIPTION_COMPARISON_FAILURE = 'NSIPS_PRESCRIPTION_COMPARISON_FAILURE'
export const NSIPS_REPORT_EDIT_CLEAR_USAGES = 'NSIPS_REPORT_EDIT_CLEAR_USAGES'

export const NSIPS_RELATION_SITUATIONS_SEARCH = 'NSIPS_RELATION_SITUATIONS_SEARCH'
export const NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS = 'NSIPS_RELATION_SITUATIONS_SEARCH_SUCCESS'
export const NSIPS_RELATION_SITUATIONS_SEARCH_FAILURE = 'NSIPS_RELATION_SITUATIONS_SEARCH_FAILURE'

export const NS_PATIENTS_SEARCH = 'NS_PATIENTS_SEARCH'
export const NS_PATIENTS_SEARCH_SUCCESS = 'NS_PATIENTS_SEARCH_SUCCESS'
export const NS_PATIENTS_SEARCH_FAILURE = 'NS_PATIENTS_SEARCH_FAILURE'
export const NS_PATIENT_SEARCH = 'NS_PATIENT_SEARCH'
export const NS_PATIENT_SEARCH_SUCCESS = 'NS_PATIENT_SEARCH_SUCCESS'
export const NS_PATIENT_SEARCH_FAILURE = 'NS_PATIENT_SEARCH_FAILURE'
export const NS_PATIENT_MATCHING = 'NS_PATIENT_MATCHING'
export const NS_PATIENT_MATCHING_SUCCESS = 'NS_PATIENT_MATCHING_SUCCESS'
export const NS_PATIENT_MATCHING_FAILURE = 'NS_PATIENT_MATCHING_FAILURE'

export const NS_CLINICS_SEARCH = 'NS_CLINICS_SEARCH'
export const NS_CLINICS_SEARCH_SUCCESS = 'NS_CLINICS_SEARCH_SUCCESS'
export const NS_CLINICS_SEARCH_FAILURE = 'NS_CLINICS_SEARCH_FAILURE'
export const NS_CLINIC_SEARCH = 'NS_CLINIC_SEARCH'
export const NS_CLINIC_SEARCH_SUCCESS = 'NS_CLINIC_SEARCH_SUCCESS'
export const NS_CLINIC_SEARCH_FAILURE = 'NS_CLINIC_SEARCH_FAILURE'
export const NS_CLINIC_MATCHING = 'NS_CLINIC_MATCHING'
export const NS_CLINIC_MATCHING_SUCCESS = 'NS_CLINIC_MATCHING_SUCCESS'
export const NS_CLINIC_MATCHING_FAILURE = 'NS_CLINIC_MATCHING_FAILURE'
export const NS_CLINIC_AUTOCOMPLETE_CLEAR = 'NS_CLINIC_AUTOCOMPLETE_CLEAR'

export const NS_DOCTORS_SEARCH = 'NS_DOCTORS_SEARCH'
export const NS_DOCTORS_SEARCH_SUCCESS = 'NS_DOCTORS_SEARCH_SUCCESS'
export const NS_DOCTORS_SEARCH_FAILURE = 'NS_DOCTORS_SEARCH_FAILURE'
export const NS_DOCTOR_SEARCH = 'NS_DOCTOR_SEARCH'
export const NS_DOCTOR_SEARCH_SUCCESS = 'NS_DOCTOR_SEARCH_SUCCESS'
export const NS_DOCTOR_SEARCH_FAILURE = 'NS_DOCTOR_SEARCH_FAILURE'
export const NS_DOCTOR_MATCHING = 'NS_DOCTOR_MATCHING'
export const NS_DOCTOR_MATCHING_SUCCESS = 'NS_DOCTOR_MATCHING_SUCCESS'
export const NS_DOCTOR_MATCHING_FAILURE = 'NS_DOCTOR_MATCHING_FAILURE'
export const NS_DOCTOR_AUTOCOMPLETE_CLEAR = 'NS_DOCTOR_AUTOCOMPLETE_CLEAR'

export const NS_CHECK = 'NS_CHECK'
export const NS_CHECK_SUCCESS = 'NS_CHECK_SUCCESS'
export const NS_CHECK_FAILURE = 'NS_CHECK_FAILURE'

export const NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE = 'NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE'
export const NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_SUCCESS = 'NSIPS_RELATION_SITUATIONS_PATIENT_SUCCESS'
export const NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE_FAILURE = 'NSIPS_RELATION_SITUATIONS_PATIENT_FAILURE'
export const NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE = 'NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE'
export const NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS = 'NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_SUCCESS'
export const NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE = 'NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE_FAILURE'
export const NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE = 'NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE'
export const NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS = 'NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_SUCCESS'
export const NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE = 'NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE_FAILURE'

export const OUTPATIENT_SEARCH = 'OUTPATIENT_SEARCH'
export const OUTPATIENT_SEARCH_SUCCESS = 'OUTPATIENT_SEARCH_SUCCESS'
export const OUTPATIENT_SEARCH_FAILURE = 'OUTPATIENT_SEARCH_FAILURE'
export const OUTPATIENT_CLEAR = 'OUTPATIENT_CLEAR'
export const OUTPATIENT_DETAIL_CLEAR = 'OUTPATIENT_DETAIL_CLEAR'
export const OUTPATIENT_EDIT_CLEAR = 'OUTPATIENT_EDIT_CLEAR'
export const OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS = 'OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS'
export const OUTPATIENT_AUTOCOMPLETE_CLEAR = 'OUTPATIENT_AUTOCOMPLETE_CLEAR'
export const OUTPATIENT_SEARCH_DETAIL = 'OUTPATIENT_SEARCH_DETAIL'
export const OUTPATIENT_SEARCH_DETAIL_FAILURE = 'OUTPATIENT_SEARCH_DETAIL_FAILURE'
export const OUTPATIENT_SEARCH_DETAIL_SUCCESS = 'OUTPATIENT_SEARCH_DETAIL_SUCCESS'
export const OUTPATIENT_EDIT = 'OUTPATIENT_EDIT'
export const OUTPATIENT_EDIT_FAILURE = 'OUTPATIENT_EDIT_FAILURE'
export const OUTPATIENT_EDIT_SUCCESS = 'OUTPATIENT_EDIT_SUCCESS'
export const OUTPATIENT_DELETE = 'OUTPATIENT_DELETE'
export const OUTPATIENT_DELETE_FAILURE = 'OUTPATIENT_DELETE_FAILURE'
export const OUTPATIENT_DELETE_SUCCESS = 'OUTPATIENT_DELETE_SUCCESS'
export const OUTPATIENT_SEARCH_PATIENT_CODE = 'OUTPATIENT_SEARCH_PATIENT_CODE'
export const OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE = 'OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE'
export const OUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS = 'OOUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS'
export const OUTPATIENT_DUPLICATE_CHECK = 'OUTPATIENT_DUPLICATE_CHECK'
export const OUTPATIENT_DUPLICATE_CHECK_SUCCESS = 'OUTPATIENT_DUPLICATE_CHECK_SUCCESS'
export const OUTPATIENT_DUPLICATE_CHECK_FAILURE = 'OUTPATIENT_DUPLICATE_CHECK_FAILURE'
export const OUTPATIENT_MSG_ALERT = 'OUTPATIENT_MSG_ALERT'



// WEBPACK FOOTER //
// ./src/store/modules/mutation-types.js